export default {
    common: {
        title: 'Content AI',
        socialPlanner: 'Social planlægger',
        blog: 'Blog',
        funnel: 'Tragt',
        website: 'Hjemmeside',
        mediaLibrary: 'Mediebibliotek',
        email: 'Email',
        words: 'Ord',
        variations: 'Variationer',
        thisIsPaidService: 'Denne funktion er en betalt service og vil medføre gebyrer baseret på din brug',
        all: 'Alle',
    },
};
